import type { LocaleCode, LocaleMetadata } from "../types";

import { getCountryDefinition } from "./country-definitions";
import { deriveCountryCodes } from "./derive-country-codes";
import { parseLocaleCode } from "./parse-locale-code";

function deriveLocaleMetadata(code: LocaleCode): LocaleMetadata {
  const { iso3166Alpha2Lower, language } = parseLocaleCode(code);
  const countryDefinition = getCountryDefinition(iso3166Alpha2Lower);
  const countryCodes = deriveCountryCodes(iso3166Alpha2Lower);

  return {
    canonicalOrigin: `https://www.${countryDefinition.domain}`,
    code,
    country: countryCodes,
    domain: countryDefinition.domain,
    language,
    siteId: countryDefinition.domain,
  };
}

export { deriveLocaleMetadata };
